const PENDING_ORDER_KEY = 'pendingPurchaseOrderId';
const VERIFIED_ORDER_KEY = 'verifiedPurchaseOrderId';

export function markPendingPurchaseOrderId(orderId) {
    if (!orderId) {
        return;
    }

    sessionStorage.setItem(PENDING_ORDER_KEY, String(orderId));
}

export function clearPendingPurchaseOrderId() {
    sessionStorage.removeItem(PENDING_ORDER_KEY);
}

export function resolvePendingPurchaseOrderId() {
    return sessionStorage.getItem(PENDING_ORDER_KEY);
}

export function markVerifiedPurchaseOrderId(orderId) {
    if (!orderId) {
        return;
    }

    sessionStorage.setItem(VERIFIED_ORDER_KEY, String(orderId));
}

export function consumeVerifiedPurchaseOrderId(orderId) {
    if (!orderId) {
        return false;
    }

    const verified = sessionStorage.getItem(VERIFIED_ORDER_KEY);
    if (verified && verified === String(orderId)) {
        sessionStorage.removeItem(VERIFIED_ORDER_KEY);
        return true;
    }

    return false;
}

/**
 * Build a payment redirect <form> from confirm API HTML (Monobank/LiqPay).
 * Prefer parsing the response string — DOM v-html may be cleared before submit.
 */
export function resolvePaymentRedirectForm(orderResult, paymentFormElement = null) {
    if (paymentFormElement) {
        return paymentFormElement;
    }

    const html = typeof orderResult === 'string'
        ? orderResult
        : (typeof orderResult?.data === 'string' ? orderResult.data : null);

    if (!html || !html.includes('liqpay-form')) {
        return null;
    }

    const container = document.createElement('div');
    container.innerHTML = html;
    const form = container.querySelector('#liqpay-form');
    if (!form) {
        return null;
    }

    // Detached forms cannot be submitted in some browsers — mount briefly.
    form.style.display = 'none';
    document.body.appendChild(form);
    return form;
}

/**
 * Resolve order id from confirm API response (JSON or payment HTML).
 */
export function extractOrderIdFromPaymentResponse(orderResult, paymentFormElement = null) {
    if (orderResult && typeof orderResult === 'object' && !Array.isArray(orderResult)) {
        const nested = orderResult.data && typeof orderResult.data === 'object' ? orderResult.data : null;
        const id = orderResult.orderId
            || orderResult.order_id
            || nested?.orderId
            || nested?.order_id;

        if (id) {
            return String(id);
        }
    }

    if (typeof orderResult === 'string') {
        const attrMatch = orderResult.match(/data-order-id=["'](\d+)["']/i);
        if (attrMatch?.[1]) {
            return attrMatch[1];
        }

        const dataMatch = orderResult.match(/name=["']data["']\s+value=["']([^"']+)["']/i);
        if (dataMatch?.[1]) {
            try {
                const decoded = JSON.parse(atob(dataMatch[1].replace(/\s/g, '')));
                const liqPayOrderId = decoded.order_id || decoded.orderId;
                if (liqPayOrderId) {
                    return String(liqPayOrderId);
                }
            } catch (error) {
                // ignore decode errors
            }
        }
    }

    if (paymentFormElement) {
        const fromAttr = paymentFormElement.getAttribute('data-order-id');
        if (fromAttr) {
            return String(fromAttr);
        }
    }

    return null;
}
